import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { PostContent } from "PFApp/components/card_tx/content/post_content";
import { Footer } from "PFApp/components/card_tx/footer/footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type DefaultVariantProps = Pick<
  CardTxContentProps,
  "task" | "type" | "isFeed" | "isDraft" | "handleShare" | "handleRefetchActivities"
>;

export const DefaultVariant = ({
  task,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleRefetchActivities
}: DefaultVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    task,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={task.private} isDraft={isDraft} />
      <PostContent task={task} />
      <Footer participants={task.participants} />
    </>
  );
};
